import { Component, inject, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { ServiceSettingsVisitTypeStore } from './service-settings-visit-type.store';
import { SubscriptionComponent } from '../../../../../shared/helpers/subscription.component';
import { ConfirmBuilder } from '../../../../../shared/service/confirm.builder';
import { activeColumn, descriptionColumn, nameColumn } from '../../../../../shared/components/kit/table/table.fields';
import { TableComponent } from '../../../../../shared/components/kit/table/table.component';
import { contentGlobalSuccess } from '../../../../content.error';
import { isAllowed, routeParams, translate } from '../../../../../shared/shared.global-service';
import {
    ServiceSettingsVisitTypeUpsertDialogComponent,
} from './service-settings-visit-type-upsert-dialog/service-settings-visit-type-upsert-dialog.component';
import {
    ServiceVisitTypeObject,
} from '@libs/types/src/services/object-type/service/settings/service-visit-type.object';
import { visitTypeQuery } from './service-settings-visit-type.query';
import { BaseDialogService } from '../../../../../../components/kit/base-dialog/base-dialog-service';
import { CardTableComponent } from '../../../../../shared/components/kit/table/card-table.component';

@Component({
    selector: 'app-service-settings-visit-type',
    templateUrl: 'service-settings-visit-type.component.html',
    styleUrl: 'service-settings-visit-type.component.scss',
    providers: [ServiceSettingsVisitTypeStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CardTableComponent,
    ],
})
export class ServiceSettingsVisitTypeComponent extends SubscriptionComponent {

    public readonly store = inject(ServiceSettingsVisitTypeStore);
    public readonly confirm = inject(ConfirmBuilder);
    public readonly dialog = inject(BaseDialogService);

    @ViewChild('table') table!: TableComponent;

    protected columns = [
        activeColumn,
        nameColumn,
        descriptionColumn,
    ];

    constructor() {
        super();
        this.store.onSuccess(
            () => this.table?.reload(),
            'createServiceVisitType',
            'updateServiceVisitType',
            'deleteServiceVisitType',
        );
    }

    protected update(item?: ServiceVisitTypeObject): void {
        this.dialog.open(
            ServiceSettingsVisitTypeUpsertDialogComponent,
            {
                header: translate.instant('service.settings.general.visitType.label'),
                width: '50vw',
                data: { item },
            },
        ).onClose.subscribe(async (it: any) => {
            if (it) {
                if (item) {
                    await this.store.api.updateServiceVisitType({
                        id: item.id,
                        ...it,
                    });
                    contentGlobalSuccess.next('common.updated');
                } else {
                    await this.store.api.createServiceVisitType({
                        serviceId: Number(routeParams.serviceId()),
                        ...it,
                    });
                    contentGlobalSuccess.next('common.created');
                }
            }
        });
    }

    protected delete(event: any): void {
        this.confirm.confirmDelete(
            async () => {
                await this.store.api.deleteServiceVisitType({ id: event.item.id });
                contentGlobalSuccess.next('common.deleted');
            },
            event,
        );
    }

    protected readonly routeParams = routeParams;
    protected readonly visitTypeQuery = visitTypeQuery;
    protected readonly isAllowed = isAllowed;
}
